<template>
  <cookie-law
    theme="dark-lime--rounded"
    :button-decline="true"
    button-text="Accept"
  >
    <div slot="message">
      This site uses cookies to help you get the best experience. To find out more read
      <a :href="$t('privacyUrl')">our privacy policy</a>.
    </div>
  </cookie-law>
</template>

<script>
import CookieLaw from 'vue-cookie-law';

export default {
  components: {
    CookieLaw,
  },
};
</script>
